import type { IconRecord } from '../types/icons';

export const getIconKey = (iconsList: IconRecord, key: string) => {
  const iconKey = iconsList[key as keyof typeof iconsList];
  return iconKey;
};
